import React from 'react'
import { Share2, Instagram, Youtube, Video, Facebook } from 'lucide-react'
import { Card, CardHeader, CardTitle, CardContent, Input } from '../ui'
import { FormField } from '../form'

interface VehicleSocialMediaProps {
  videoUrl?: string
  instagramUrl?: string
  youtubeUrl?: string
  tiktokUrl?: string
  facebookUrl?: string
  onFieldChange: (field: any, value: string) => void
}

export const VehicleSocialMedia: React.FC<VehicleSocialMediaProps> = ({
  videoUrl,
  instagramUrl,
  youtubeUrl,
  tiktokUrl,
  facebookUrl,
  onFieldChange,
}) => {
  return (
    <Card>
      <CardHeader>
        <CardTitle className="flex items-center">
          <Share2 className="h-5 w-5 mr-2 text-accent" />
          Vídeos e Redes Sociais
        </CardTitle>
      </CardHeader>
      <CardContent className="space-y-6">
        {/* Vídeo */}
        <FormField label="URL do Vídeo" hint="Cole o link de um vídeo do veículo (YouTube, Vimeo, etc)">
          <div className="relative">
            <Video className="absolute left-3 top-1/2 -translate-y-1/2 h-4 w-4 text-muted-foreground pointer-events-none" />
            <Input
              value={videoUrl || ''}
              onChange={(e) => onFieldChange('videoUrl', e.target.value)}
              placeholder="https://youtube.com/watch?v=..."
              className="pl-9"
            />
          </div>
        </FormField>

        {/* Redes Sociais */}
        <div className="border-t border-border pt-4">
          <p className="text-xs font-semibold uppercase tracking-widest text-muted-foreground mb-4">
            Redes Sociais (Opcional)
          </p>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
            <FormField label="Instagram">
              <div className="relative">
                <Instagram className="absolute left-3 top-1/2 -translate-y-1/2 h-4 w-4 text-muted-foreground pointer-events-none" />
                <Input
                  value={instagramUrl || ''}
                  onChange={(e) => onFieldChange('instagramUrl', e.target.value)}
                  placeholder="https://instagram.com/..."
                  className="pl-9"
                />
              </div>
            </FormField>

            <FormField label="YouTube">
              <div className="relative">
                <Youtube className="absolute left-3 top-1/2 -translate-y-1/2 h-4 w-4 text-muted-foreground pointer-events-none" />
                <Input
                  value={youtubeUrl || ''}
                  onChange={(e) => onFieldChange('youtubeUrl', e.target.value)}
                  placeholder="https://youtube.com/@..."
                  className="pl-9"
                />
              </div>
            </FormField>

            <FormField label="TikTok">
              <div className="relative">
                <Video className="absolute left-3 top-1/2 -translate-y-1/2 h-4 w-4 text-muted-foreground pointer-events-none" />
                <Input
                  value={tiktokUrl || ''}
                  onChange={(e) => onFieldChange('tiktokUrl', e.target.value)}
                  placeholder="https://tiktok.com/@..."
                  className="pl-9"
                />
              </div>
            </FormField>

            <FormField label="Facebook">
              <div className="relative">
                <Facebook className="absolute left-3 top-1/2 -translate-y-1/2 h-4 w-4 text-muted-foreground pointer-events-none" />
                <Input
                  value={facebookUrl || ''}
                  onChange={(e) => onFieldChange('facebookUrl', e.target.value)}
                  placeholder="https://facebook.com/..."
                  className="pl-9"
                />
              </div>
            </FormField>
          </div>
        </div>
      </CardContent>
    </Card>
  )
}
